import type { auth } from "@monorepo/auth";
import { env } from "@monorepo/env/dashboard";
import { queryOptions } from "@tanstack/react-query";
import {
  genericOAuthClient,
  inferAdditionalFields,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: env.VITE_EXPERIENCE_API_URL,
  plugins: [genericOAuthClient(), inferAdditionalFields<typeof auth>()],
});

export const { useSession } = authClient;

export type SessionData = Awaited<
  ReturnType<typeof authClient.getSession>
>["data"];

const SESSION_STALE_TIME = 5 * 60 * 1000;

export const sessionQueryOptions = queryOptions<SessionData>({
  queryKey: ["auth", "session"],
  queryFn: async () => {
    const result = await authClient.getSession();
    return result.data;
  },
  staleTime: SESSION_STALE_TIME,
  gcTime: SESSION_STALE_TIME,
  refetchOnWindowFocus: true,
  retry: false,
});
